import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  card: {
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  productSearchBox: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
  },
  productList: {
    maxHeight: '400px',
    overflowY: 'auto',
    marginTop: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  productItem: {
    padding: theme.spacing(1),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  selectedProduct: {
    backgroundColor: theme.palette.action.selected,
  },
  baseProductSection: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  actionButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  createDialogTitle: {
    color: 'white',
    width: '100%',
  },
  createDialogOptions: {
    padding: theme.spacing(2),
  },
  createDialogButtons: {
    height: '55px',
    width: '240px',
    background: '#24335E',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    textAlign: 'center',
    color: 'white',
  },
  createDialogTexfield: {
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  compareProductsContainer: {
    animation: '$slideInFromLeft 0.5s ease-out',
    padding: theme.spacing(2),
  },
  '@keyframes slideInFromLeft': {
    '0%': {
      transform: 'translateX(-100%)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateX(0)',
      opacity: 1,
    },
  },
}));

export default useStyles;
